import { useQuery } from "@tanstack/react-query";
import { testingAxios, testingAuthHeaders } from "@/services/testing";
import { PLANS_ENDPOINT } from "@/services/testing";
import type { TestPlan } from "@/services/testing";
import { useAuthStoreV1 } from "@/stores/authStore_v1";

async function fetchPlans(): Promise<TestPlan[]> {
  const r = await testingAxios.get<TestPlan[]>(PLANS_ENDPOINT, { headers: testingAuthHeaders() });
  return r.data;
}

export function usePlans() {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const userId = useAuthStoreV1((s) => s.user?.id ?? null);
  return useQuery({
    queryKey: ["testingPlans", orgId],
    queryFn: fetchPlans,
    enabled: !!(token && orgId && userId),
    refetchOnWindowFocus: false,
    // Background list fetch — a transient failure (service busy mid-run) must not
    // raise the global error toast; react-query retries and it self-heals.
    meta: { silent: true },
    retry: 3,
  });
}
